import Vue from 'vue';
import axios from 'axios';
import router from '../router';
import cryptojs from 'crypto-js'
import store from '../store';
import analytic, { EventBus } from '../main';

export default {

    async login(data) {
        EventBus.$emit('show-loading', true);
        return await axios
            .post('login', data)
            .then(response => {
                EventBus.$emit('show-loading', false);

                const data = response.data;
                const access_token = data.session.access_token;
                const client_id = data.session.client_id;
                const user = data.people;
                const companies = data.companies;
                const session = data.session;
                console.log(companies);
                store.dispatch('company/setSelectedCompany', companies[0].id ); 
                store.dispatch('user/setUser', user);
                store.dispatch('auth/setSessions', session)
                store.dispatch('company/setCompanies', companies);
                store.dispatch('company/setCurrentCompany', companies[0]);

                //Base64 token - client_id:access_token
                var rawStr = client_id + ':' + access_token
                var wordArray = cryptojs.enc.Utf8.parse(rawStr)
                var base64 = cryptojs.enc.Base64.stringify(wordArray)
                var authorization_token = 'Basic ' + base64;
                var raw_token = base64;
                store.dispatch('auth/setRawToken', base64);

                // //Set localStorage items
                localStorage.setItem('status', 'Logged in');
                localStorage.setItem('token', authorization_token);
                localStorage.setItem('companies', JSON.stringify(companies));
                localStorage.setItem('raw_token', raw_token);

                //Set Authorization to Base64 value
                axios.defaults.headers.common['Authorization'] = authorization_token;
                let authSuccessData = {
                    authorization_token: authorization_token,
                    raw_token: raw_token
                };
                store.dispatch('auth/setAuthSuccess', authSuccessData)
                // commit('auth_success', authorization_token, raw_token)
                // Event tracking

                analytic.$ga.event({
                    eventCategory: 'User',
                    eventAction: 'Logged in'
                });

                router.push('/');  
                router.go();
            })
            .catch(error => {
                console.log(error);
                EventBus.$emit('show-loading', false);
                // commit('auth_error')
                localStorage.removeItem('token');
                localStorage.removeItem('raw_token');
                Vue.prototype.$generalAPIErrorHandling(error, router);
            })
    },

    async register(data) {
        let email = data.email;
        let password = data.password;
        let client_id = cryptojs.MD5( Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)).toString();
        EventBus.$emit('show-loading', true);
        return await axios
            .post('/signup', data)
            .then(() => {
                EventBus.$emit('show-loading', false);
                let loginData = {
                    email: email,
                    password : password,
                    client_id : client_id
                }
                this.login(loginData);

            })
            .catch(error => {
                console.log(error);
                EventBus.$emit('show-loading', false);

            })
    }
}
